import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _slicedToArray from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js";
import _asyncToGenerator from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _defineProperty from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
import _regeneratorRuntime from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.regexp.flags.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es7.object.entries.js";
import "core-js/modules/es6.object.keys.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { mixpanelService } from '@haogentech/mxp-util';
import { getExperimentsIdWithFallback, getExperimentsFromCookie, setExperimentsCookie, hasAllEligibility, mergeEligibility } from "../../utils/experiments";
var LMS_URL = process.env.VUE_APP_LMS_URL || '';

// new_portal is eligibility-gated in LMS, so a plain device fetch never
// returns it. Requesting it here labels this portal's events with
// experiment__new_portal (the control arm's "original") — without it, direct
// visitors carry no property and the arms cannot be separated in funnels.
var NEW_PORTAL_ELIGIBILITY = 'new_portal';
var state = {
  flags: {},
  eoe: {},
  eligibility: '',
  experimentsId: null,
  flagsReady: false,
  isInitializing: false
};

// LMS serves an experiment under `eoe` once it has ended with a pinned fixed
// variant (never while live, even at 100%), so both buckets have to be read
// together or a finished experiment looks unresolved.
var allVariants = function allVariants(state) {
  return _objectSpread(_objectSpread({}, state.eoe), state.flags);
};
var mutations = {
  SET_FLAGS: function SET_FLAGS(state, flags) {
    state.flags = _objectSpread({}, flags);
  },
  SET_EOE: function SET_EOE(state, eoe) {
    state.eoe = _objectSpread({}, eoe);
  },
  SET_ELIGIBILITY: function SET_ELIGIBILITY(state, eligibility) {
    state.eligibility = eligibility;
  },
  SET_EXPERIMENTS_ID: function SET_EXPERIMENTS_ID(state, id) {
    state.experimentsId = id;
  },
  SET_FLAGS_READY: function SET_FLAGS_READY(state, isReady) {
    state.flagsReady = isReady;
  },
  SET_INITIALIZING: function SET_INITIALIZING(state, val) {
    state.isInitializing = val;
  }
};
var actions = {
  initializeFlags: function initializeFlags(_ref) {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var commit, dispatch, state, identity, _t;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit, dispatch = _ref.dispatch, state = _ref.state;
            if (!(state.flagsReady || state.isInitializing)) {
              _context.next = 1;
              break;
            }
            return _context.abrupt("return");
          case 1:
            commit('SET_INITIALIZING', true);
            _context.prev = 2;
            _context.next = 3;
            return getExperimentsIdWithFallback();
          case 3:
            identity = _context.sent;
            commit('SET_EXPERIMENTS_ID', identity);
            _context.next = 4;
            return dispatch('fetchExperiments', NEW_PORTAL_ELIGIBILITY);
          case 4:
            _context.next = 5;
            return dispatch('registerToMixpanel');
          case 5:
            commit('SET_FLAGS_READY', true);
            _context.next = 7;
            break;
          case 6:
            _context.prev = 6;
            _t = _context["catch"](2);
            console.error('[Experiments] Init failed:', _t);
            commit('SET_FLAGS', {});
            commit('SET_EOE', {});
            commit('SET_FLAGS_READY', true);
          case 7:
            _context.prev = 7;
            commit('SET_INITIALIZING', false);
            return _context.finish(7);
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 6, 7, 8]]);
    }))();
  },
  fetchExperiments: function fetchExperiments(_ref2) {
    var _arguments = arguments;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var commit, state, newEligibility, cookieData, identity, mergedEligibility, params, response, data, responseExperiments, responseEoe, experiments, eoe, _t2, _t3;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            commit = _ref2.commit, state = _ref2.state;
            newEligibility = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : null;
            cookieData = getExperimentsFromCookie();
            _t2 = state.experimentsId;
            if (_t2) {
              _context2.next = 2;
              break;
            }
            _context2.next = 1;
            return getExperimentsIdWithFallback();
          case 1:
            _t2 = _context2.sent;
          case 2:
            identity = _t2;
            if (!(newEligibility && cookieData && hasAllEligibility(cookieData.eligibility, newEligibility))) {
              _context2.next = 3;
              break;
            }
            commit('SET_FLAGS', cookieData.experiments);
            commit('SET_EOE', cookieData.eoe || {});
            commit('SET_ELIGIBILITY', cookieData.eligibility);
            return _context2.abrupt("return", cookieData.experiments);
          case 3:
            if (!(!newEligibility && cookieData)) {
              _context2.next = 4;
              break;
            }
            commit('SET_FLAGS', cookieData.experiments);
            commit('SET_EOE', cookieData.eoe || {});
            commit('SET_ELIGIBILITY', cookieData.eligibility || '');
            return _context2.abrupt("return", cookieData.experiments);
          case 4:
            if (LMS_URL) {
              _context2.next = 5;
              break;
            }
            console.warn('[Experiments] LMS_URL not configured');
            return _context2.abrupt("return", {});
          case 5:
            mergedEligibility = newEligibility ? mergeEligibility((cookieData === null || cookieData === void 0 ? void 0 : cookieData.eligibility) || '', newEligibility) : '';
            params = new URLSearchParams({
              identity: identity,
              identityType: 'device'
            });
            if (mergedEligibility) params.set('eligibility', mergedEligibility);
            _context2.prev = 6;
            _context2.next = 7;
            return fetch("".concat(LMS_URL, "/experiments?").concat(params));
          case 7:
            response = _context2.sent;
            _context2.next = 8;
            return response.json();
          case 8:
            data = _context2.sent;
            // The API answers { experiments, eoe }; treating the whole payload as
            // the variant map used to register garbage props and write the wrapped
            // object into the shared mb__experiments cookie, corrupting it for the
            // marketing site and the new portal too.
            responseExperiments = (data === null || data === void 0 ? void 0 : data.experiments) || {};
            responseEoe = (data === null || data === void 0 ? void 0 : data.eoe) || {};
            experiments = newEligibility ? _objectSpread(_objectSpread({}, (cookieData === null || cookieData === void 0 ? void 0 : cookieData.experiments) || {}), responseExperiments) : responseExperiments;
            eoe = _objectSpread(_objectSpread({}, (cookieData === null || cookieData === void 0 ? void 0 : cookieData.eoe) || {}), responseEoe);
            commit('SET_FLAGS', experiments);
            commit('SET_EOE', eoe);
            commit('SET_ELIGIBILITY', mergedEligibility);
            setExperimentsCookie(experiments, eoe, mergedEligibility);
            return _context2.abrupt("return", experiments);
          case 9:
            _context2.prev = 9;
            _t3 = _context2["catch"](6);
            console.error('[Experiments] Fetch failed:', _t3);
            return _context2.abrupt("return", {});
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[6, 9]]);
    }))();
  },
  registerToMixpanel: function registerToMixpanel(_ref3) {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var state, props, _t4;
      return _regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            state = _ref3.state;
            _context3.prev = 1;
            if (mixpanelService) {
              _context3.next = 2;
              break;
            }
            return _context3.abrupt("return");
          case 2:
            props = Object.fromEntries(Object.entries(allVariants(state)).map(function (_ref4) {
              var _ref5 = _slicedToArray(_ref4, 2),
                name = _ref5[0],
                variant = _ref5[1];
              return ["experiment__".concat(name), variant];
            }));
            if (Object.keys(props).length > 0) {
              mixpanelService.register(props);
            }
            _context3.next = 4;
            break;
          case 3:
            _context3.prev = 3;
            _t4 = _context3["catch"](1);
            console.warn('[Experiments] Mixpanel registration failed:', _t4);
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[1, 3]]);
    }))();
  },
  // Backward compatibility
  initializeFlagsmith: function initializeFlagsmith(_ref6) {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var dispatch;
      return _regeneratorRuntime.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            dispatch = _ref6.dispatch;
            return _context4.abrupt("return", dispatch('initializeFlags'));
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  },
  identifyUser: function identifyUser() {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      return _regeneratorRuntime.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  },
  reIdentifyUser: function reIdentifyUser(_ref7) {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var dispatch;
      return _regeneratorRuntime.wrap(function (_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            dispatch = _ref7.dispatch;
            return _context6.abrupt("return", dispatch('identifyUser'));
          case 1:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  }
};
var getters = {
  flags: function flags(state) {
    return state.flags;
  },
  flagsReady: function flagsReady(state) {
    return state.flagsReady;
  },
  experimentsId: function experimentsId(state) {
    return state.experimentsId;
  },
  eligibility: function eligibility(state) {
    return state.eligibility;
  },
  getFlag: function getFlag(state) {
    return function (key) {
      var _allVariants$key;
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'original';
      return (_allVariants$key = allVariants(state)[key]) !== null && _allVariants$key !== void 0 ? _allVariants$key : defaultValue;
    };
  },
  getExperimentVariant: function getExperimentVariant(state) {
    return function (key) {
      return allVariants(state)[key] || 'original';
    };
  },
  isNewVariant: function isNewVariant(state) {
    return function (key) {
      return allVariants(state)[key] === 'new';
    };
  },
  isOriginalVariant: function isOriginalVariant(state) {
    return function (key) {
      var variant = allVariants(state)[key];
      return !variant || variant === 'original';
    };
  },
  buildExperimentsMeta: function buildExperimentsMeta(state) {
    return function () {
      return Object.fromEntries(Object.entries(allVariants(state)).map(function (_ref8) {
        var _ref9 = _slicedToArray(_ref8, 2),
          name = _ref9[0],
          variant = _ref9[1];
        return ["experiment_".concat(name), variant];
      }));
    };
  },
  getRawExperiments: function getRawExperiments(state) {
    return function () {
      return allVariants(state);
    };
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};